const WORLD_CUP_COUNTRY_FLAGS = {
  algeria: "🇩🇿",
  argentina: "🇦🇷",
  australia: "🇦🇺",
  austria: "🇦🇹",
  belgium: "🇧🇪",
  bosnia: "🇧🇦",
  brazil: "🇧🇷",
  "cabo verde": "🇨🇻",
  canada: "🇨🇦",
  czechia: "🇨🇿",
  chile: "🇨🇱",
  china: "🇨🇳",
  colombia: "🇨🇴",
  "congo dr": "🇨🇩",
  "costa rica": "🇨🇷",
  "côte d'ivoire": "🇨🇮 ",
  croatia: "🇭🇷",
  curaçao: "🇨🇼 ",
  denmark: "🇩🇰",
  ecuador: "🇪🇨",
  egypt: "🇪🇬",
  england: "🏴",
  france: "🇫🇷",
  germany: "🇩🇪",
  ghana: "🇬🇭",
  greece: "🇬🇷",
  haiti: "🇭🇹 ",
  iceland: "🇮🇸",
  iran: "🇮🇷",
  iraq: "🇮🇶",
  italy: "🇮🇹",
  japan: "🇯🇵",
  jordan: "🇯🇴",
  "korea rep": "🇰🇷",
  mexico: "🇲🇽",
  morocco: "🇲🇦",
  netherlands: "🇳🇱",
  "new zealand": "🇳🇿",
  nigeria: "🇳🇬",
  norway: "🇳🇴",
  panama: "🇵🇦",
  paraguay: "🇵🇾",
  peru: "🇵🇪",
  poland: "🇵🇱",
  portugal: "🇵🇹",
  qatar: "🇶🇦",
  russia: "🇷🇺",
  "saudi arabia": "🇸🇦",
  scotland: "🏴",
  senegal: "🇸🇳",
  serbia: "🇷🇸",
  "south africa": "🇿🇦",
  spain: "🇪🇸",
  sweden: "🇸🇪",
  switzerland: "🇨🇭",
  tunisia: "🇹🇳",
  turkey: "🇹🇷",
  türkiye: "🇹🇷",
  ukraine: "🇺🇦",
  "united states": "🇺🇸",
  "united states of america": "🇺🇸",
  uruguay: "🇺🇾",
  usa: "🇺🇸",
  uzbekistan: "🇺🇿",
  wales: "🏴",
};

const normalizeCountryName = (name) =>
  String(name || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

export const getWorldCupCountryFlag = (name) => WORLD_CUP_COUNTRY_FLAGS[normalizeCountryName(name)] || "";
